import { makeAutoObservable } from 'mobx'
import React from 'react'

import { AppButtonVariant } from 'components/AppButton/AppButton'

import { ReactComponent as CloseCircleRedIcon } from 'assets/images/svg/close_circle_red.svg'
import { ReactComponent as MessageTextIcon } from 'assets/images/svg/message_text.svg'

export type ModalButton = {
  text: string
  onClick?(): void
  variant?: AppButtonVariant
}

export type ModalData = {
  title: string
  description: string
  buttons?: ModalButton[]
  icon?: React.ReactNode
}

interface ErrorData {
  title?: string
  text?: string
}

export class DialogStore {
  visible: boolean = false
  title: string = ''
  description: string = ''
  buttons: ModalButton[] = []
  icon: React.ReactNode | null = null

  constructor() {
    makeAutoObservable(
      this,
      {},
      {
        autoBind: true,
      },
    )
  }
  openErrorModal({
    title = 'Произошла ошибка',
    text = 'Неизвестная ошибка',
  }: ErrorData) {
    this.openModal({
      title,
      description: text,
      icon: <CloseCircleRedIcon />,
    })
  }
  openModal(data: ModalData) {
    this.visible = true
    this.title = data.title
    this.description = data.description
    this.buttons = data.buttons || [
      {
        text: 'Закрыть',
      },
    ]
    this.icon = data?.icon || null
  }

  openCommentModal(comment: string) {
    this.openModal({
      title: 'Комментарий',
      icon: <MessageTextIcon />,
      description: comment,
    })
  }

  openTextModal(comment: string) {
    this.openModal({
      title: 'Текст сообщения',
      icon: <MessageTextIcon />,
      description: comment,
    })
  }

  closeModal() {
    this.visible = false

    this.title = ''
    this.description = ''
    this.buttons = []
  }
}
